module.exports = __webpack_public_path__ + "static/media/390x310-Dallas.30662bfc.jpg";